export default "__VITE_ASSET__d728b65e__"